import { render, staticRenderFns } from "./AutoFix.vue?vue&type=template&id=3fb26506"
import script from "./AutoFix.vue?vue&type=script&lang=js"
export * from "./AutoFix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports